module.exports = __webpack_public_path__ + "img/heardigits.0b2a12f2.png";